@if(pwaService.isPwa() && !networkService.isOnline && showOfflineBanner && !appOffline() && pwaService.hasOfflineWorkspace){
<div class="fixed z-20 flex w-[-webkit-fill-available] justify-between bg-yellow-50 px-4 py-3">
        <div class="flex items-center gap-2">
            <bizz-icon iconName="circle-exclamation" class="size-6 text-yellow-600"></bizz-icon>
            <span class="text-xs text-yellow-900 sm:text-sm">
                {{'BizzmineIsOfflineSwitchToYour' | translate}} <b>{{'OfflineWorkspace' | translate}}</b> {{'ToAccessSyncRecordsAndFolders' | translate}}
            </span>

        </div>
        <div class="flex items-center gap-3">
            <button class="h-8 bg-yellow-600 text-[10px] text-white sm:text-xs" (click)="confirm()">{{'GoToOfflineWorkspace' | translate}}</button>
            <bizz-icon class="block size-4 text-yellow-900"  iconName="xmark"
                [hover]="true">
            </bizz-icon>
        </div>
</div>
}


@if(showOnlineBanner && networkService.isOnline && pwaService.hasOfflineWorkspace){
    <div class="fixed z-20 mt-3 flex w-[-webkit-fill-available] justify-center">
        <div class="flex items-center justify-between gap-x-3 rounded-lg bg-blue-50 px-4 py-3">
            <bizz-icon iconName="circle-exclamation" class="size-6 text-blue-600"></bizz-icon>
            <span class="text-xs text-blue-900 sm:text-sm">{{ "Info_OfflineWorkspaceInternetConnectionReestablished" | translate }}</span>
            <bizz-icon class="block size-4 text-blue-900"  iconName="xmark"
            [hover]="true">
        </bizz-icon>
    </div>
    </div>
}
